module.exports = __webpack_public_path__ + "assets/img/logo-eternia.5f94c7c7.jpg";